"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var RaceType;
(function (RaceType) {
    RaceType["MOUNTAIN_BIKE"] = "mountainbike";
    RaceType["TRIATHLON"] = "triathlon";
    RaceType["LAKE"] = "lake";
    RaceType["CYCLING"] = "cycling";
    RaceType["OBSTACLE"] = "obstacle";
    RaceType["RUNNING"] = "running";
    RaceType["STAIRS"] = "stairs";
    RaceType["SWIM"] = "swim";
    RaceType["UNDEFINED"] = "undefined";
})(RaceType = exports.RaceType || (exports.RaceType = {}));
var IntervalRaceType;
(function (IntervalRaceType) {
    IntervalRaceType["CYCLING"] = "cycling";
    IntervalRaceType["RUNNING"] = "running";
    IntervalRaceType["SWIM"] = "swimming";
    IntervalRaceType["TRANSITION"] = "transition";
    IntervalRaceType["UNDEFINED"] = "undefined";
})(IntervalRaceType = exports.IntervalRaceType || (exports.IntervalRaceType = {}));
var RaceTimeType;
(function (RaceTimeType) {
    RaceTimeType["CHIP"] = "CHIP";
    RaceTimeType["GUN"] = "GUN";
    RaceTimeType["UNDEFINED"] = "UNDEFINED";
})(RaceTimeType = exports.RaceTimeType || (exports.RaceTimeType = {}));
function cleanInputs(rawRaceType) {
    return rawRaceType ? rawRaceType.replace(/[^0-9a-zA-Z]/g, '') : undefined;
}
exports.cleanInputs = cleanInputs;
function emptyToUndefined(str) {
    return str === '' ? undefined : str;
}
exports.emptyToUndefined = emptyToUndefined;
var raceTimeTypeMap = (_a = {},
    _a['chip'] = function () { return RaceTimeType.CHIP; },
    _a['gun'] = function () { return RaceTimeType.GUN; },
    _a);
var raceTypeMap = (_b = {},
    _b['adventureracing'] = function () { return RaceType.MOUNTAIN_BIKE; },
    _b['aquabike'] = function () { return RaceType.TRIATHLON; },
    _b['aquathlon'] = function () { return RaceType.TRIATHLON; },
    _b['canoekayak'] = function () { return RaceType.LAKE; },
    _b['criterium'] = function () { return RaceType.CYCLING; },
    _b['cycling'] = function () { return RaceType.CYCLING; },
    _b['cyclocross'] = function () { return RaceType.CYCLING; },
    _b['duathlon'] = function () { return RaceType.TRIATHLON; },
    _b['funrun'] = function () { return RaceType.RUNNING; },
    _b['mountainbiking'] = function () { return RaceType.MOUNTAIN_BIKE; },
    _b['mountainclimb'] = function () { return RaceType.MOUNTAIN_BIKE; },
    _b['obstacle'] = function () { return RaceType.OBSTACLE; },
    _b['orienteering'] = function () { return RaceType.RUNNING; },
    _b['paddletriathlon'] = function () { return RaceType.LAKE; },
    _b['paddleboarding'] = function () { return RaceType.LAKE; },
    _b['racewalk'] = function () { return RaceType.RUNNING; },
    _b['racewalking'] = function () { return RaceType.RUNNING; },
    _b['running'] = function () { return RaceType.RUNNING; },
    _b['run'] = function () { return RaceType.RUNNING; },
    _b['skicrosscountry'] = function () { return RaceType.RUNNING; },
    _b['snowshoerunning'] = function () { return RaceType.RUNNING; },
    _b['stairclimb'] = function () { return RaceType.STAIRS; },
    _b['swimming'] = function () { return RaceType.SWIM; },
    _b['trailrunning'] = function () { return RaceType.RUNNING; },
    _b['trailrunninghiking'] = function () { return RaceType.RUNNING; },
    _b['triathlonmultisport'] = function () { return RaceType.TRIATHLON; },
    _b);
var intervalRaceTypeMap = (_c = {},
    _c['triathlon'] = function () { return IntervalRaceType.UNDEFINED; },
    _c['moutainbiking'] = function () { return IntervalRaceType.CYCLING; },
    _c['mountainbike'] = function () { return IntervalRaceType.CYCLING; },
    _c['cycling'] = function () { return IntervalRaceType.CYCLING; },
    _c['cycle'] = function () { return IntervalRaceType.CYCLING; },
    _c['bike'] = function () { return IntervalRaceType.CYCLING; },
    _c['swimming'] = function () { return IntervalRaceType.SWIM; },
    _c['swim'] = function () { return IntervalRaceType.SWIM; },
    _c['multisport'] = function () { return IntervalRaceType.RUNNING; },
    _c['obstacle'] = function () { return IntervalRaceType.RUNNING; },
    _c['transition'] = function () { return IntervalRaceType.TRANSITION; },
    _c['running'] = function () { return IntervalRaceType.RUNNING; },
    _c['run'] = function () { return IntervalRaceType.RUNNING; },
    _c['undefined'] = function () { return IntervalRaceType.UNDEFINED; },
    _c);
function normalizeRaceType(possibleRaceType) {
    var mapper = raceTypeMap[lodash_1.flow(cleanInputs, lodash_1.toLower, emptyToUndefined)(possibleRaceType)];
    return (mapper) ? mapper() : RaceType.UNDEFINED;
}
exports.normalizeRaceType = normalizeRaceType;
function normalizeRaceTimeType(possibleRaceTimeType) {
    var mapper = raceTimeTypeMap[lodash_1.flow(cleanInputs, lodash_1.toLower, emptyToUndefined)(possibleRaceTimeType)];
    return (mapper) ? mapper() : RaceTimeType.UNDEFINED;
}
exports.normalizeRaceTimeType = normalizeRaceTimeType;
function normalizeIntervalRaceType(possibleRaceType) {
    var mapper = intervalRaceTypeMap[lodash_1.flow(cleanInputs, lodash_1.toLower, emptyToUndefined)(possibleRaceType)];
    return (mapper) ? mapper() : IntervalRaceType.UNDEFINED;
}
exports.normalizeIntervalRaceType = normalizeIntervalRaceType;
//# sourceMappingURL=raceType.js.map